import * as yup from "yup";

export const initialValues_forgotPwd ={
    email : ""
}

export const validationSchema_forgotPwd = yup.object().shape({
    email : yup.string().required("Required").email("Invalid email")
})